const ModuleIdentifierConst = {
  ORGANISATION: 'organizationManagement',
  ATTRIBUTE: 'userAttributeManagement',
  ROLE: 'roleManagement',
  USER: 'user',
  PERMISSION: 'permissionsManagement',
  INCENTIVE: 'incentiveManagement',
  VENDOR: 'vendor',
  CERTIFICATE: 'certificate',
};

export default ModuleIdentifierConst;
